import React from 'react';

// ColorLegend Component
export const ColorLegend = ({ colors, baseHeight, lowestPoint, highestPoint }) => {
    const gradientColors = colors
        .map(([offset, color]) => `${color} ${(offset * 100).toFixed(1)}%`)
        .join(', ');

    return (
        <div className="color-legend-container">
            <p className="select-header">
                {__('js_map_measuring_tools.color_legend')}
            </p>
            <div
                className="color-legend-gradient"
                style={{
                    background: `linear-gradient(to top, ${gradientColors})`,
                }}
            >
                <div className="color-legend-label color-legend-label-top">
                    {highestPoint.toFixed(2)} m
                </div>
                <div className="color-legend-label color-legend-label-middle">
                    {baseHeight.toFixed(2)} m
                </div>
                <div className="color-legend-label color-legend-label-bottom">
                    {lowestPoint.toFixed(2)} m
                </div>
            </div>
        </div>
    )
};